import { from } from "core-js/fn/array"
import {empty} from "./functions"
import {createEvent, restore}  from "effector";
import { tryParseJSON } from "./functions";
import axios from "axios";
import {getCustomUserAgent} from "./customUserAgent";

interface ILSUserAgentData {
    uuid?: string,
    session?: string,
    instance_token?: string,
    phone?: string,
}

export function getInstanceToken(): string {
    // return lsGetUserAgentDataItem("ru.krasabs.asb_web_lk/0.0.1 (web-lk)", "instance_token")
    return lsGetUserAgentDataItem("ru.krasabs.asb_web_lk/0.0.1 (web-lk)", "instance_token")
}

export function setInstanceToken(token: string) {
    return lsSetUserAgentDataItem("ru.krasabs.asb_web_lk/0.0.1 (web-lk)", "instance_token", token)
}

export function getPhone(): string {
    return lsGetUserAgentDataItem("ru.krasabs.asb_web_lk/0.0.1 (web-lk)", "phone")
}

export function setPhone(uuid: string) {
    return lsSetUserAgentDataItem("ru.krasabs.asb_web_lk/0.0.1 (web-lk)", "phone", uuid)
}

export function getUuidAndSession() {
    return {uuid: getUuid(), session: getSession()}
}

export function getUuid(): string {
    return lsGetUserAgentDataItem("ru.krasabs.asb_web_lk/0.0.1 (web-lk)", "uuid")
}

export function setUuid(uuid: string) {
    return lsSetUserAgentDataItem("ru.krasabs.asb_web_lk/0.0.1 (web-lk)", "uuid", uuid)
}

export function getSession(): string {
    return lsGetUserAgentDataItem("ru.krasabs.asb_web_lk/0.0.1 (web-lk)", "session")
}

export function setSession(session: string) {
    return lsSetUserAgentDataItem("ru.krasabs.asb_web_lk/0.0.1 (web-lk)", "session", session)
}
export function getEmail(): string {
    return lsGetUserAgentDataItem("ru.krasabs.asb_web_lk/0.0.1 (web-lk)", "email")
}
export function setEmail(email: string) {
    return lsSetUserAgentDataItem("ru.krasabs.asb_web_lk/0.0.1 (web-lk)", "email", email)
}
export function removeStorageData() {
    localStorage.removeItem("ru.krasabs.asb_web_lk/0.0.1 (web-lk)")
}

export function lsRemoveUserAgentData(ua: string) {
    localStorage.removeItem(ua)
}

export function lsSetUserAgentDataItem(ua: string, key: string, val: string) {
    let data = lsGetUserAgentData(ua)
    //@ts-ignore
    data[key] = val
    lsSetUserAgentData(ua, data)
}

export function lsGetUserAgentDataItem(ua: string, key: string): string{
    //@ts-ignore
    let val = lsGetUserAgentData(ua)[key]
    return val == undefined ? "" : val as string
}

export function lsSetUserAgentData(ua: string, data: ILSUserAgentData) {
    localStorage.setItem(ua, JSON.stringify(data))
}

export function lsGetUserAgentData(ua: string): ILSUserAgentData {
    let data = tryParseJSON(localStorage.getItem(ua))
    return data as ILSUserAgentData
}
